import { o as o_util } from "../chunks/common-namespaces-client-DhfOpdyM.mjs";
const misc = o_util.misc ?? {};
const getPagecluster = misc.getPagecluster;
const guid = misc.guid;
const isPreview = misc.isPreview;
const isPrivacyPage = misc.isPrivacyPage;
const isValidMouseButton = misc.isValidMouseButton;
const nanoid = misc.nanoid;
const setVendorStyle = misc.setVendorStyle;
const urlToLinkObject = misc.urlToLinkObject;
const isResponsive = misc.isResponsive;
export {
  getPagecluster,
  guid,
  isPreview,
  isPrivacyPage,
  isResponsive,
  isValidMouseButton,
  misc,
  nanoid,
  setVendorStyle,
  urlToLinkObject
};
/*                                    */
